"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    id: "bc264565-b1f0-4375-a359-b9119d4a444b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 503.87 504.52",
    width: "100%",
    height: "100%",
    children: [(0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("path", {
        d: "M280.51,0C165.48,0,71.9,93.58,71.9,208.61s93.58,208.61,208.61,208.61,208.6-93.59,208.6-208.61S395.53,0,280.51,0Zm0,405.22C172.1,405.22,83.9,317,83.9,208.61S172.1,12,280.51,12s196.6,88.2,196.6,196.61S388.92,405.22,280.51,405.22Z",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("path", {
        d: "M412.93,97.57a174.78,174.78,0,0,0-20.28-20.44A172.6,172.6,0,0,0,159.74,85a174.63,174.63,0,0,0-16,17.94c-1.66,2.14-3.27,4.33-4.83,6.55a173,173,0,0,0-16.29,28.65q-2.47,5.52-4.57,11.23a172.72,172.72,0,0,0,30.17,170.44q3.74,4.44,7.75,8.62a172.58,172.58,0,0,0,228.15,18.5A177,177,0,0,0,399,334.37q5.67-5.36,10.85-11.2,3.69-4.16,7.1-8.53a171.82,171.82,0,0,0,35.08-84.41,175.27,175.27,0,0,0,1.35-21.62A172.16,172.16,0,0,0,412.93,97.57ZM280.51,261a52.37,52.37,0,1,1,52.36-52.36A52.37,52.37,0,0,1,280.51,261Z",
        fill: "currentColor"
      })]
    }), (0, jsx_runtime_1.jsx)("rect", {
      x: "57.14",
      y: "466.88",
      width: "446.73",
      height: "37.64",
      rx: "6.22",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("rect", {
      x: "187.85",
      y: "424.15",
      width: "185.32",
      height: "37.64",
      rx: "4.01",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("path", {
        d: "M187.43,412.63a5,5,0,0,1-1.69-.3L145.88,398a5,5,0,1,1,3.38-9.42l39.86,14.32a5,5,0,0,1-1.69,9.71Z",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("path", {
        d: "M127.54,391.12a5,5,0,0,1-1.69-.3L86,376.51a5,5,0,0,1,3.38-9.41l39.87,14.31a5,5,0,0,1-1.69,9.71Z",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("path", {
        d: "M67.64,369.61a5,5,0,0,1-1.69-.3L26.09,355a5,5,0,1,1,3.38-9.41L69.33,359.9a5,5,0,0,1-1.69,9.71Z",
        fill: "currentColor"
      })]
    }), (0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("path", {
        d: "M170.45,424.44a5.22,5.22,0,0,1-1.1-.12L128,415a5,5,0,1,1,2.2-9.76l41.31,9.35a5,5,0,0,1-1.1,9.88Z",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("path", {
        d: "M108.38,410.39a5.22,5.22,0,0,1-1.1-.12L66,400.92a5,5,0,1,1,2.2-9.76l41.31,9.35a5,5,0,0,1-1.1,9.88Z",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("path", {
        d: "M46.31,396.34a5.22,5.22,0,0,1-1.1-.12L3.9,386.87a5,5,0,1,1,2.21-9.76l41.3,9.35a5,5,0,0,1-1.1,9.88Z",
        fill: "currentColor"
      })]
    })]
  });
};

exports.default = Icon;